"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Range_1 = __importDefault(require("../../../../Util/Range"));
class RecoveryModel {
    constructor(cache, logger) {
        this.setDay = async (customerId, day) => {
            await this.cache
                .setObject(this.dayKey(customerId, day.date), day)
                .asPromise();
            this.logger.log(`Recovery Day for ${customerId} in ${day.date} Saved`);
        };
        this.getDay = async (customerId, date) => {
            const day = (await this.cache
                .getObject(this.dayKey(customerId, date))
                .asPromise());
            if (day.recovery.sleepHoursRange !== null) {
                day.recovery.sleepHoursRange = new Range_1.default(day.recovery.sleepHoursRange.from, day.recovery.sleepHoursRange.to);
            }
            return day;
        };
        this.dayKey = (customerId, date) => {
            return `Mock.Database.Recovery.${customerId}.${date}`;
        };
        this.cache = cache;
        this.logger = logger;
    }
}
exports.default = RecoveryModel;
//# sourceMappingURL=RecoveryModel.js.map